import './../../scss/theme/components/stage.scss';

//move img 100px up by percent of the scroll
const stageFigure = document.querySelector('.stage .image > figure'),
  stageImg = stageFigure.querySelector('img');

if(stageImg){
  window.addEventListener('scroll', () => {
    let figureHeight = stageFigure.offsetHeight,
      imageHeight = stageImg.offsetHeight,
      scrolled = window.scrollY,
      scrollPercentage = scrolled / imageHeight,
      offset = imageHeight - figureHeight;

    stageImg.style.transform = `translateY(-${scrollPercentage * offset}px)`;
  });
}

function typewriter(lettersContainer, speed) {
  if(!lettersContainer) return
  const letters = lettersContainer.innerText.split('');
  lettersContainer.innerHTML = '';
  letters.forEach(letter => {
    const span = document.createElement('span');
    span.innerText = letter;
    lettersContainer.appendChild(span);
  });
  const spans = lettersContainer.querySelectorAll('h1 span');
  spans.forEach((span, index) => {
    setTimeout(() => {
      span.classList.add('showing');

      setTimeout(() => {
        span.classList.remove('showing');
        span.classList.add('show');
      }, speed);
    }, speed * index);
  });
}

if(document.querySelector('h1.typewriter')) typewriter(document.querySelector('h1.typewriter bdo'), 50 );
